import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    justifyContent: 'space-between',
    gap: '20px',
    width: '100%',
    alignItems: {
      md: 'center',
    },
    padding: {
      xs: '20px 24px',
      md: '48px 0px',
    },
  },
  cardImage: {
    height: '320px',
  },
  cardsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
  },
  actionButton: {
    alignSelf: 'center',
    mt: { xs: '20px', md: '32px' },
  },
  previewCardDescription: {},
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
